import { Component, ViewChild } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { PermissionsService } from '../../../services/permissions/permissions.service';
import { ImplementerNavigatorComponent } from '../implementer-navigator-component/implementer-navigator-component';
import { AppConfig } from '../../../app/app.config';
import { SupportContextKey } from '../../../models/support/support.models';
import { SupportContextService } from '../../../services/support/support-context.service';

@IonicPage()
@Component({
  selector: 'page-implementer-navigator',
  templateUrl: 'implementer-navigator.html',
})
export class ImplementerNavigatorPage {
  @ViewChild('implementerNavigator') implementerNavigator: ImplementerNavigatorComponent;

  config = AppConfig.settings;

  constructor(public navCtrl: NavController,
              public navParams: NavParams,
              private permissionService: PermissionsService,
              private supportContextService: SupportContextService,
  ) {
  }

  ionViewDidLoad() {

  }

  ionViewDidEnter() {
    this.supportContextService.setComponentContext(SupportContextKey.ImplementerMode, 'Implementer Mode', 'ImplementerNavigatorPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/implementer/implementer-navigator/implementer-navigator.ts